import {Fragment} from "react";
import {WordPressQuotePackageList} from "./WordPressQuotePackageList";
import {WordPressQuoteMovingItems} from "./WordPressQuoteMovingItems";
import {WordPressQuoteCarList} from "./WordPressQuoteCarList";
import {WordPressQuotePalletList} from "./WordPressQuotePalletList";
import {WordPressQuoteCustomsItemList} from "./WordPressQuoteCustomsItemList";
import {WordPressQuoteFTL} from "./WordPressQuoteFTL";

export const WordPressQuoteShippingDetails = ({
                                                  tab,
                                                  cbHandleShippingDetails,
                                                  validatedResult,
                                                  lng,
                                                  movingFrom,
                                                  movingTo,
                                                  HSCodeError,
                                                  validateEmailAddress,
                                                  cbHandleValidatedEmail,
                                                  contact,
                                                  cbHandleMovingDate,
                                                  cbHandleMovingSkid,
                                                  cbHandleSkidList,
                                                  movingType,
                                                  cbHandleMovingType,
                                                  cbHandleResidenceDetails
                                              }) => {

    return (
        <Fragment>
            {
                tab === 'car' ?
                    <WordPressQuoteCarList cbHandleShippingDetails={cbHandleShippingDetails}
                                           validatedResult={validatedResult}
                                           lng={lng}/>
                    :
                    tab === 'moving' ?
                        <WordPressQuoteMovingItems cbHandleShippingDetails={cbHandleShippingDetails}
                                                   validatedResult={validatedResult}
                                                   lng={lng}
                                                   cbHandleMovingDate={cbHandleMovingDate}
                                                   cbHandleMovingSkid={cbHandleMovingSkid}
                                                   cbHandleSkidList={cbHandleSkidList}
                                                   movingType={movingType}
                                                   cbHandleMovingType={cbHandleMovingType}
                                                   cbHandleResidenceDetails={cbHandleResidenceDetails}/>
                        :
                        tab === 'ltl' ?
                            <WordPressQuotePalletList cbHandleShippingDetails={cbHandleShippingDetails}
                                                      validatedResult={validatedResult}
                                                      lng={lng}/>
                            :
                            tab === 'package' ?
                                <WordPressQuotePackageList cbHandleShippingDetails={cbHandleShippingDetails}
                                                           validatedResult={validatedResult}
                                                           lng={lng}/>
                                :
                                tab === 'brokerage' ?
                                    <WordPressQuoteCustomsItemList cbHandleShippingDetails={cbHandleShippingDetails}
                                                                   validatedResult={validatedResult}
                                                                   movingFrom={movingFrom}
                                                                   movingTo={movingTo}
                                                                   HSCodeError={HSCodeError}
                                                                   validateEmailAddress={validateEmailAddress}
                                                                   cbHandleValidatedEmail={cbHandleValidatedEmail}
                                                                   contact={contact}
                                                                   lng={lng}/>
                                    :
                                    <WordPressQuoteFTL cbHandleShippingDetails={cbHandleShippingDetails}
                                                       validatedResult={validatedResult}
                                                       lng={lng}/>

            }
        </Fragment>
    )
}